import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const typographyThemeToken: any = {
  //==================== COLORS ====================//
  colorPrimary: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryActive: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryHover: variableColors["ColorFigmaComplementaryBlue40"],

  colorError: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorActive: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorHover: variableColors["ColorFigmaFunctionalAlert50"],

  colorLink: variableColors["ColorFigmaComplementaryBlue50"],
  colorLinkActive: variableColors["ColorFigmaComplementaryBlue50"],
  colorLinkHover: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryBorder: variableColors["ColorFigmaComplementaryBlue50"],

  colorSuccess: variableColors["ColorFigmaFunctionalSuccess50"],
  colorWarning: variableColors["ColorFigmaFunctionalWarning50"],

  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextDescription: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  colorTextHeading: variableColors["ColorFigmaNeutralGrayscaleGray90"],

  //==================== FONT SIZE ====================//

  fontSize: variableTypography["BodyLargeFontSize"],
  fontSizeSmall: variableTypography["BodySmallFontSize"],
  fontMediumSmall: variableTypography["BodyMediumFontSize"],
  fontSizeHeading1: variableTypography["BodyH800FontSize"],
  fontSizeHeading2: variableTypography["BodyH700FontSize"],
  fontSizeHeading3: variableTypography["BodyH600FontSize"],
  fontSizeHeading4: variableTypography["BodyH500FontSize"],
  fontSizeHeading5: variableTypography["BodyH400FontSize"],

  lineHeight: variableTypography["BodyLargeLineHeight"],
  lineHeightHeading1: variableTypography["BodyH800LineHeight"],
  lineHeightHeading2: variableTypography["BodyH700LineHeight"],
  lineHeightHeading3: variableTypography["BodyH600LineHeight"],
  lineHeightHeading4: variableTypography["BodyH500LineHeight"],
  lineHeightHeading5: variableTypography["BodyH400LineHeight"],

  //==================== EFFECTS ====================//
  marginXS: 0,
  marginXXS: 0,
  paddingSM: 0,
  titleMarginBottom: 0,
  titleMarginTop: 0,

  fontFamily: variableTypography["BodyLargeFontFamily"],
  fontFamilyCode: variableTypography["BodyLargeFontFamily"],
  fontWeightStrong: variableTypography["BodyH800FontWeight"],
};
